import http from '../utils/http.js'
import md5 from 'js-md5';
export function pageQuery(data) {
    // {
    //     "username": ""
    //   }
    return http.post(`/account/pageQuery/${data.page}/${data.size}`, data)
}


export function add(data) {
    return http.post(`/partyBuilding/add`, data)
}

export function changeState(data) {
    return http.post(`/account/changeState`, data)
}
export function update(data) {
    return http.put(`/partyBuilding/update`, data)
}
export function del(ids) {
    return http.delete(`/partyBuilding/del`, ids)
}

export function toResetPassword(data) {
    return http.post(`/account/toResetPassword`, { ...data, oldPassword: data.oldPassword ? md5(data.oldPassword) : '', newPassword: md5(data.newPassword) })
}
// 获取代办
export function getStateNum() {
    return http.get(`/account/getStateNum`)
}